"use client";
import Image from "next/image";
const ApplicationButton = () => {
	return (
		<div className={"flex flex-col items-center"}>
			<a
				href="https://docs.google.com/forms/d/e/1FAIpQLScs0womKCqqgQjud6E3P_0NnOmn8ZSMJn6qzZrfiG_xzU1VUA/viewform?usp=sharing"
				target="_blank"
				rel="noopener noreferrer"
				className={
					"rounded-full py-4 px-24 bg-red-600 w-fit text-white font-bold text-3xl"
				}
			>
				応募する
			</a>
			<p className={"text-red-600 font-bold"}>〆切：3月28日（金）</p>
		</div>
	);
};

const Events2025Spring = () => {
	return (
		<main className="flex flex-col justify-center w-full gap-4">
			<div className="w-full">
				<Image
					src="/events/2025spring/ogp.svg"
					alt="Background"
					width={800}
					height={800}
					className="w-full h-auto"
					priority
				/>
			</div>
			<ApplicationButton />
		</main>
	);
};

export default Events2025Spring;
